import React, { createContext, useMemo } from 'react'
import {
  IContent,
  IFooter,
  IHeader,
  IPage,
  IPageMeta,
  IPageSEO,
  ISiteMeta,
} from '../../types'

export const PageContext = createContext<IPage | null>({} as IPage)
export const PageMetaContext = createContext<IPageMeta | null>(null)
export const PageContentContext = createContext<IContent | null>(null)
export const PageHeaderContext = createContext<IHeader | null>(null)
export const PageSeoContext = createContext<IPageSEO | null>(null)
export const PageFooterContext = createContext<IFooter | null>(null)
export const PageSiteMetaContext = createContext<ISiteMeta | null>(null)

type Props = {
  children: React.ReactNode
  page: IPage
}

export const PageProvider = ({ children, page }: Props) => {
  const pageValue = useMemo(() => page || null, [page])
  const pageMetaValue = useMemo(() => page?.PageMeta || null, [page?.PageMeta])
  const pageContentValue = useMemo(() => page?.Content || null, [page?.Content])
  const pageHeaderValue = useMemo(() => page?.Header || null, [page?.Header])
  const pageSeoValue = useMemo(() => page?.SEO || null, [page?.SEO])
  const pageFooterValue = useMemo(() => page?.Footer || null, [page?.Footer])
  const siteMetaValue = useMemo(() => page?.SiteMeta || null, [page?.SiteMeta])

  return (
    <PageSiteMetaContext.Provider value={siteMetaValue}>
      <PageFooterContext.Provider value={pageFooterValue}>
        <PageSeoContext.Provider value={pageSeoValue}>
          <PageHeaderContext.Provider value={pageHeaderValue}>
            <PageContentContext.Provider value={pageContentValue}>
              <PageMetaContext.Provider value={pageMetaValue}>
                <PageContext.Provider value={pageValue}>
                  {children}
                </PageContext.Provider>
              </PageMetaContext.Provider>
            </PageContentContext.Provider>
          </PageHeaderContext.Provider>
        </PageSeoContext.Provider>
      </PageFooterContext.Provider>
    </PageSiteMetaContext.Provider>
  )
}
